import { onMounted, onBeforeUnmount } from 'vue';

export function useClickAway(targetRef, handler, eventType = 'mousedown') {
  const handleClick = (event) => {
    const el = targetRef.value;
    if (!el || el.contains(event.target)) return;
    handler(event);
  };

  onMounted(() => {
    document.addEventListener(eventType, handleClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener(eventType, handleClick);
  });
}
